import config from "../config"
const baseUrl = config.base_url + "z_farm_work_pesticide_fertilizer_category/"
export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    tree: {
        url: baseUrl + "tree",
        type: "get",
    },
    children: {
        url: baseUrl + "children",
        type: "get",
    },
    listByLevel: {
        url: baseUrl + "listByLevel",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    getByCode: {
        url: baseUrl + "getByCode",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    firstLevelOptions: {
        url: baseUrl + "firstLevelOptions",
        type: "get",
    },
    secondLevelOptions: {
        url: baseUrl + "secondLevelOptions",
        type: "get",
    },
    thirdLevelOptions: {
        url: baseUrl + "thirdLevelOptions",
        type: "get",
    },
    allOptions: {
        url: baseUrl + "allOptions",
        type: "get",
    },
}


